module.exports = __webpack_public_path__ + "static/media/eye.613bf78b.svg";